import * as React from 'react'

import { AppSidebarMinimal } from '../containers/AppSidebarMinimal'
import { LegalFooter } from '@/modules/legal'

type Props = {
  children?: React.ReactNode
}

// Layout for pages that exist outside a company context — used by the
// subscription onboarding flow (/post-register, /checkout, /subscription/*).
// Same chrome as the main app (logo, language switcher, logout in the sidebar)
// but without company-scoped navigation buttons.
export const AppLayoutNoCompany = ({ children }: Props) => (
  <div className="tw-flex tw-min-h-screen !tw-bg-content-primary" data-test-id="LayoutNoCompany">
    <AppSidebarMinimal />
    {/* Stopka z danymi kontaktowymi i linkami prawnymi towarzyszy całej
        ścieżce zakupowej — wymóg weryfikacyjny Przelewy24. */}
    <div className="tw-flex tw-flex-1 tw-flex-col">
      <div className="tw-flex-1">{children}</div>
      <LegalFooter />
    </div>
  </div>
)
